import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { common as commonApi } from 'redux/modules/api'
import { isTopUser as isTopUserFunc } from 'redux/selectors/auth'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      state => ({
        common: state.api.common,
        isTopUser: isTopUserFunc(state)
      }),
      { ...commonApi }
    )
    class Common extends Component {
      static propTypes = {
        common: PropTypes.object.isRequired,
        isTopUser: PropTypes.bool,
        getCountriesWithStructure: PropTypes.func.isRequired,
        getRegions: PropTypes.func.isRequired,
        getVersion: PropTypes.func.isRequired,
        getLocales: PropTypes.func.isRequired,
        decoFilter: PropTypes.string,
        getPublicAwardUnits: PropTypes.func.isRequired
      }

      componentDidMount() {
        const {
          common,
          isTopUser,
          getRegions,
          getCountriesWithStructure,
          getVersion,
          getLocales
        } = this.props

        if (
          config.countries &&
          (!common.countries.loading || !common.countries.loaded)
        ) {
          this.handleCountriesWithStructure()
        }

        if (config.countriesWithStructure) {
          !common.ics.loading && getCountriesWithStructure()
        }

        if (config.regions) {
          !common.regions.loaded && getRegions()
        }

        if (config.version) {
          !common.version.loaded && getVersion()
        }

        if (config.locales) {
          if (!common.locales.loaded || common.locales.lastFetchedFor !== isTopUser) {
            getLocales(isTopUser)
          }
        }
      }

      handleCountriesWithStructure = ({ filterCase, filterId } = {}) =>
        this.props.getCountriesWithStructure(
          this.handleGetBaseFilter({ filterCase, filterId })
        )

      handleGetBaseFilter = ({ filterCase, filterId } = {}) => {
        const { decoFilter } = this.props

        switch (filterCase || decoFilter || config.filter) {
          case 'regionCountries':
            return `region.id=${filterId}`
          default:
            return ''
        }
      }

      handleGetPublicAwardUnits = ({ countryId } = {}) =>
        this.props.getPublicAwardUnits({ countryId })

      render() {
        return (
          <ComposedComponent
            {...this.props}
            fetchCountriesWithStructure={this.handleCountriesWithStructure}
            fetchPublicAwardUnits={this.handleGetPublicAwardUnits}
          />
        )
      }
    }
    return Common
  }
}

export default decorator
